import { Route, Routes } from "react-router-dom";

import { AdminLayout } from "layouts/AdminLayout";
import { isProduct, ProductId } from "multitenancy/product";

import { UploadingFileProvider } from "features/ValidationModal/context";

import Attendant from "pages/app/Attendant";
import { AttendantRole } from "pages/app/AttendantRole";
import { Audiences } from "pages/app/audiences";
import { CustomerTemplate } from "pages/app/CustomerTemplate";
import { Dashboard } from "pages/app/dashboard";
import { Documents } from "pages/app/Documents";
import { FullRecordingView } from "pages/app/FullRecordingView";
import { FullViewPage } from "pages/app/FullView";
import { HearingFileType } from "pages/app/HearingFileType";
import { HearingFileTypeAttendantRole } from "pages/app/HearingFileTypeAttendantRole";
import HearingRecord from "pages/app/HearingRecord";
import HearingRecordLocal from "pages/app/HearingRecordLocal";
import HearingRecordMConf from "pages/app/HearingRecordMConf";
import { HearingSource } from "pages/app/HearingSource";
import { HearingType } from "pages/app/HearingType";
import { HearingTypeAttendantRole } from "pages/app/HearingTypeAttendantRole";
import IframeFinishRedirect from "pages/app/IframeFinishRedirect";
import { CustomerCertificate } from "pages/app/ImportCertificateLogged";
import { Profiles } from "pages/app/Profiles";
import { LogError } from "pages/app/ReportsKenta/LogError";
import { LoggedUsers } from "pages/app/ReportsKenta/LoggedUsers";
import { LogOperations } from "pages/app/ReportsKenta/LogOperations";
import { ReportMenu } from "pages/app/ReportsKenta/ReportMenu";
import { TranscriptionReport } from "pages/app/ReportsKenta/Transcriptions";
import RoleMapAd from "pages/app/RoleMapAd";
import { ServiceIntegrationImportation } from "pages/app/ServiceIntegrationImportation";
import { SystemConfiguration } from "pages/app/systemConfiguration";
import { Unit } from "pages/app/Unit";
import CreateUsers from "pages/app/UserCustomer";
import { ChangePassword } from "pages/auth/changePassword";
import { ForgotPassword } from "pages/auth/forgotPassword";
import { ImportCertificate } from "pages/auth/importCertificateLoggedOut";
import { SignIn } from "pages/auth/signIn";
import InviteRoomFinished from "pages/InviteRoomFinished";
import InviteRoomResult from "pages/InviteRoomResult";
import NotFoundPage from "pages/NotFoundPage";
import RecordingViewer from "pages/RecordingViewer";
import VerificationCode from "pages/VerificationCode";

import { AuthStateGuard } from "routers/AuthStateGuard";
import PublicRoute from "routers/PublicRoute";

import { ProtectedRoute } from "./ProtectoredRoute";

export const routeElements = (
  <>
    {/* logged out */}
    <Route
      path="/"
      element={
        <PublicRoute>
          <SignIn />
        </PublicRoute>
      }
    />
    <Route
      path="/master"
      element={
        <PublicRoute>
          <SignIn forceMaster />
        </PublicRoute>
      }
    />
    <Route path="/*" element={<NotFoundPage />} />

    <Route path="/inviteRoomResult/:token" element={<InviteRoomResult />} />
    <Route path="/MeetingRoomExit" element={<InviteRoomFinished />} />

    <Route
      path="/importCertificate"
      element={
        <PublicRoute>
          <ImportCertificate />
        </PublicRoute>
      }
    />
    <Route
      path="/forgotPassword"
      element={
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      }
    />

    <Route
      path="/changePassword/guid/:guid"
      element={
        <PublicRoute>
          <ChangePassword />
        </PublicRoute>
      }
    />

    <Route path="/iframeRedirect" element={<IframeFinishRedirect />} />

    <Route
      path="/inviteRoom"
      element={
        <PublicRoute>
          <VerificationCode />
        </PublicRoute>
      }
    />
    <Route path="/recordingViewer" element={<RecordingViewer />} />

    {/* logged */}
    <Route
      path="/audiences"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <UploadingFileProvider>
              <Audiences />
            </UploadingFileProvider>
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/audiences/fullview"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <FullViewPage />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/audiences/fullrecording"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <FullRecordingView />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/dashboard"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <UploadingFileProvider>
              <Dashboard />
            </UploadingFileProvider>
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/administration"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    >
      <Route index element={null} />
      <Route path="documents" element={<Documents />} />
      <Route path="Attendant" element={<Attendant />} />
      <Route path="AttendantRole" element={<AttendantRole />} />
      <Route path="HearingType" element={<HearingType />} />
      {isProduct(ProductId.Inquerito) && (
        <>
          <Route path="HearingSource" element={<HearingSource />} />
          <Route path="HearingFileType" element={<HearingFileType />} />
          <Route
            path="HearingFileTypeAttendantRole"
            element={<HearingFileTypeAttendantRole />}
          />
        </>
      )}
      <Route path="UserCustomerProfiles" element={<Profiles />} />
      <Route path="CustomerCertificate" element={<CustomerCertificate />} />
      <Route path="UserCustomer" element={<CreateUsers />} />
      <Route path="Place" element={<Unit />} />
      <Route
        path="hearingTypeAttendantRole"
        element={<HearingTypeAttendantRole />}
      />
      <Route path="RoleMapAd" element={<RoleMapAd />} />
      <Route path="SystemConfiguration" element={<SystemConfiguration />} />
      <Route
        path="ServiceIntegrationImportation"
        element={<ServiceIntegrationImportation />}
      />
      <Route path="CustomerTemplate" element={<CustomerTemplate />} />
    </Route>
    <Route
      path="/recording/una"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <HearingRecord />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/recording/mconf"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <HearingRecordMConf />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/recording/local"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <HearingRecordLocal />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />

    {/* ROTAS PARA RELATÓRIOS */}
    <Route
      path="/report"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <ReportMenu />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/report/TranscriptionsReport"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <TranscriptionReport />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/report/LogOperation"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <LogOperations />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/report/LogError"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <LogError />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
    <Route
      path="/report/LoggedUsers"
      element={
        <AuthStateGuard>
          <ProtectedRoute>
            <LoggedUsers />
          </ProtectedRoute>
        </AuthStateGuard>
      }
    />
  </>
);

export function Router() {
  return <Routes>{routeElements}</Routes>;
}
